import { render, staticRenderFns } from "./ReceptionModule.vue?vue&type=template&id=41776ec0&"
import script from "./ReceptionModule.vue?vue&type=script&lang=js&"
export * from "./ReceptionModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports